<template>
    <section id="section">
        <div class="tab-lists-container">
            <div class="tab-title-container">
                <div class="tab-m-title-container">
                    <i class="icon-event"></i>
                    <span class="tab-m-title">街舞赛事</span>
                </div>
                <ul class="tab-lists-title-box">
                    <li class="tab-lists-title">
                        <router-link :class="`tab-lists-link${sort ? '' : ' router-link-active'}`" to="/contests" exact>全部</router-link>
                    </li>
                    <li class="tab-lists-title" v-for="v in sorts" :key="v.id">
                        <router-link :class="`tab-lists-link${sort === v.id ? ' router-link-active' : ''}`" :to="`/contests?sort=${v.id}`" exact>{{v.name}}</router-link>
                    </li>
                </ul>
            </div>
            <div class="tab-border-container">
                <div class="tab-s-border"></div>
                <div class="tab-m-border"></div>
            </div>
        </div>

        <ul class="video-lists-box">
            <li class="video-lists" v-for="v in contests" :key="v.id">
                <router-link class="video-lists-link" :to="`/contests/${v.id}`" :title="v.title">
                    <div class="video-thumb-box">
                        <div class="video-thumb-mask"></div>
                        <img class="video-thumb" v-lazy="v.thumb" :alt="v.thumb">
                    </div>
                    <div class="video-meta-box">
                        <div class="video-title-box">
                            <h3 class="video-title ellipsis">{{v.title}}</h3>
                        </div>
                        <p class="video-count-box">
                            <span class="video-plays" :title="`发布日期: ${v.addtime}`">
                                <i class="icon-clock"></i> {{$date(v.addtime)}}
                            </span>
                            <span class="video-plays" :title="`播放量: ${v.views}`">
                                <i class="icon-video"></i> {{$view(v.views)}}
                            </span>
                        </p>
                    </div>
                </router-link>
            </li>
        </ul>

        <el-pagination v-if="contests.length && count > 40" background layout="total, prev, pager, next" :current-page="page"  @current-change="currentChange" :page-size="40" :total="count" class="pagenavi"></el-pagination>
    </section>
</template>

<script>
    export default {
        data: () => ({
            sorts: [],
            contests: [],
            count: 0,
        }),
        computed: {
            sort() {
                return +this.$route.query.sort || 0;
            },
            page() {
                return +this.$route.query.page || 1;
            }
        },
        methods: {
            currentChange(page) {// 页码改变
                this.$router.push(`/contests?sort=${this.sort}&page=${page}`);
            },
        },
        beforeRouteUpdate(to, from, next) {// 路由改变前，组件就已经渲染完了
            let {sort, page} = to.query, {api} = this;
            sort = +sort || 0;
            page = +page || 1;
            api.get('contests', {sort, page}).then(e => {
                this.contests = e.contests;
                this.count = e.count;
            }, this.err);
            next();
        },
        beforeMount() {
            const {api, sort, page} = this;

            Promise.all([
                api.get('contests/sorts').then(e => this.sorts = e),
                api.get('contests', {sort, page}).then(e => {
                    this.contests = e.contests;
                    this.count = e.count;
                }),
            ]).catch(this.err);
        }
    }
</script>

<style scoped>
    @import "../../../static/css/common/lists.css";
    @import "../../../static/css/views/home/lists.css";
    @import "../../../static/css/common/tab.css";

    .video-title {
        width: 100%;
    }

    .video-thumb-mask {
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,.2);
        -webkit-transition: opacity .3s;
        -o-transition: opacity .3s;
        transition: opacity .3s;
    }

    .video-thumb-box {
        position: relative;
    }

    .video-lists-link:hover .video-thumb-mask {
        opacity: 1;
    }
</style>


// WEBPACK FOOTER //
// src/views/contest/List.vue